import { Modal, Button } from 'react-bootstrap'

const ConfirmationModal = ({ 
    show, 
    onCancel, 
    onConfirm, 
    title, 
    body, 
    confirmText, 
    cancelText, 
    variant 
}) => {
    return (
    <Modal
        show={show}
        onHide={onCancel}
        centered
        backdrop="static"
        contentClassName="border rounded confirmation-modal"
    >

        <Modal.Header closeButton className="border-bottom p-3">
            <Modal.Title>{title || 'Confirm Action'}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="border-bottom p-3">
            <p className="mb-0">
                {body || 'Are you sure you want to delete this ad account?\nThis action cannot be undone.'}
            </p>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end gap-3 px-4 pb-4">

            <Button
                variant="outline-primary"
                size="sm"
                className="w-100 media-buying-button-action"
                style={{
                    minWidth: '160px',
                    fontSize: '14px',
                }}
                onClick={onCancel}
            >
                {cancelText || 'Cancel'}
            </Button>

            <Button
                variant={variant || "danger"}
                size="sm"
                style={{
                    minWidth: '160px',
                    backgroundColor: variant === 'danger' ? 'rgba(191, 36, 70, 1)' : undefined,
                    fontSize: '14px',
                }}
                onClick={onConfirm}
            >
                {confirmText || 'Delete Account'}
            </Button>
        </Modal.Footer>

    </Modal>
)
}

export default ConfirmationModal
